export class SubPageBannerDetails {
    public bannerImage: string = '';
    public desktopHeaderText: string = '';
    public desktopHeaderSubText: string = '';
    public mobileHeaderText: string = '';
    public mobileHeaderSubText: string = '';
    public mobileHeaderButton: string = '';
    public desktopHeaderButton: string = '';
    public topText: string = '';
}